import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery, handleSessionExpiredError } from '../../utils/auth';
import { ContractViewfinderSearchResponse } from './types';

// Define a service using a base URL and expected endpoints
export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: getBaseQuery('/mantainer-portal/manage-account'),
  endpoints: (builder) => ({
    getViewfinders: builder.query<void, void>({
      query: () => ({
        url: '/viewfinders',
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    searchViewfinders: builder.mutation<
      ContractViewfinderSearchResponse[],
      string
    >({
      query: (search) => ({
        url: '/viewfinders/filter',
        params: { search },
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    saveContractviewfindersUsers: builder.mutation<void, number[]>({
      query: (userIds) => ({
        method: 'PUT',
        url: '/viewfinders',
        body: { userIds },
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    updatePassword: builder.mutation<
      void,
      { oldPassword: string; newPassword: string }
    >({
      query: (body) => ({
        url: `/users/password`,
        method: 'PUT',
        body,
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSearchViewfindersMutation,
  useSaveContractviewfindersUsersMutation,
  useUpdatePasswordMutation,
  useGetViewfindersQuery,
} = accountApi;
